/******************************************************************************
 *                                                                            *
 *  Copyright (c) 2018, 2025 by AsterionDB Inc.                               *
 *                                                                            *
 *  All rights reserved.  No part of this work may be reproduced or otherwise *
 *  incorporated into other works without the express written consent of      *
 *  AsterionDB Inc.                                                           *
 *                                                                            *
 *****************************************************************************/

import React from 'react'
import { Nav, NavItem, NavLink, TabContent, TabPane, Row, Col } from 'reactstrap'
import classnames from 'classnames';

import UserInfo from './UserInfo.js'
import ChangePassword from './ChangePassword.js'
import UserPreferences from './UserPreferences.js'
import LoginHistory from './LoginHistory.js'
import ResourceUtilization from './ResourceUtilization.js'

import {AppContext} from '../AppContext';

class UserManagement extends React.Component
{
  constructor(props)
  {
    super();

    this.state =
    {
      tabIndex: '0',
      loginHistory: []
    }

    this.toggleTab = this.toggleTab.bind(this);
  }

  async getLoginHistory()
  {
    let result = await this.context.dbTwig.callRestAPI('icam', 'getLoginHistory');
    if ('success' !== result.status) return this.context.dbTwig.apiErrorHandler(result, 'Error retrieving login history');
    this.setState({ loginHistory: result.jsonData.loginHistory });
  }

  render()
  {
    document.title = this.context.websiteProfile.profileName + ': User Profile';
    
    return (
      <div>
        <Nav tabs>
          <NavItem>
            <NavLink
              className={classnames({ active: this.state.tabIndex === '0' })} onClick={() => { this.toggleTab('0'); }} >
              User Info
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({ active: this.state.tabIndex === '1' })} onClick={() => { this.toggleTab('1'); }} >
              Change Password
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({ active: this.state.tabIndex === '2' })} onClick={() => { this.toggleTab('2'); }} >
              Preferences
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({ active: this.state.tabIndex === '3' })} onClick={() => { this.toggleTab('3'); }} >
              Login History
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({ active: this.state.tabIndex === '4' })} onClick={() => { this.toggleTab('4'); }} >
              Resource Utilization
            </NavLink>
          </NavItem>
        </Nav>
        <TabContent activeTab={this.state.tabIndex}>
          <TabPane tabId="0">
            <Row style={{paddingTop: "10px"}}>              
              <Col sm="12">
                <UserInfo activeTab={'0' === this.state.tabIndex ? true : false}/>
              </Col>
            </Row>
          </TabPane>
          <TabPane tabId="1">
            <Row style={{paddingTop: "10px"}}>
              <Col sm="12">
                <ChangePassword activeTab={'1' === this.state.tabIndex ? true : false}/>
              </Col>
            </Row>
          </TabPane>
          <TabPane tabId="2">
            <Row style={{paddingTop: "10px"}}>
              <Col sm="12">
                <UserPreferences activeTab={'2' === this.state.tabIndex ? true : false}/>
              </Col>  
            </Row>
          </TabPane>
          <TabPane tabId="3">
            <Row style={{paddingTop: "10px"}}>
              <Col sm="12">
                <LoginHistory loginHistory={this.state.loginHistory} activeTab={'3' === this.state.tabIndex ? true : false}/>
              </Col>  
            </Row>
          </TabPane>
          <TabPane tabId="4">
            <Row style={{paddingTop: "10px"}}>
              <Col sm="12">
              { '4' === this.state.tabIndex && 
                <ResourceUtilization />
              }
                
              </Col>  
            </Row>
          </TabPane>
        </TabContent>
      </div>
    );
  }

  toggleTab(tabIndex)
  {
    if (this.state.tabIndex !== tabIndex)
    {
      if ('3' === tabIndex) this.getLoginHistory();

      this.setState({ tabIndex: tabIndex });
    }
  }
}

UserManagement.contextType = AppContext;

export default UserManagement